export default __webpack_public_path__ + "static/media/04-Gaurav-Dubey.47403843.png";